import React from 'react';
import MissionSEO from '../../components/mission/MissionSEO';
import { getMissionBySlugWithCompany, getSlugsWithCompany } from '../../store/missions/missions.service';
import PropTypes from 'prop-types';
import { hackyServerSideTranslations } from '../../i18nNext';
import { buildGuestOrLoggedInLayout } from '../../components/layout/layoutBuilder';
import { useTranslate } from '../../translate/I18n';
import { getAppUrl } from '../../utils/config';
import { buildSimpleHead, PAGES_WITH_CUSTOM_HEADER } from '../../components/layout/heading';
import { useRouter } from 'next/router';
import { cdnize } from '../../utils/pureUtils';

const { MISSION: MISSION_HEADER } = PAGES_WITH_CUSTOM_HEADER;

const MissionPage = ({ mission }) => {
  return <MissionSEO preloadedMission={mission} />;
};

MissionPage.getLayout = buildGuestOrLoggedInLayout();

/* eslint-disable react/prop-types */
MissionPage.getHead = () => props => {
  const { t } = useTranslate(['metaData']);
  const router = useRouter();
  const mission = props.mission;

  //A/B testing
  const title = t(`metaData:mission.title-${!/[0-7]/.test(mission.id[0]) ? 'A' : 'B'}`, {
    role: mission.role?.key ? t(`mission:matchingRoles.${mission.role.key}`) : '',
    location: '',
    skill1: mission.skills.hard[0]?.text,
    skill2: mission.skills.hard[1]?.text
  });
  const description = t(`metaData:mission.description-${/[0-7]/.test(mission.id[0]) ? 'A' : 'B'}`, {
    companyName: mission.company?.name,
    title: mission.title
  });
  const imageLink = cdnize('/meta/new-mission-meta.jpg');

  const link = `${getAppUrl()}${router.asPath}`;

  const DefaultHeader = buildSimpleHead(MISSION_HEADER);

  return (
    <DefaultHeader
      {...props}
      title={title}
      description={description}
      twitterImageLink={imageLink}
      link={link}
      imageLink={imageLink}
    />
  );
};

MissionPage.propTypes = {
  mission: PropTypes.object
};

export async function getStaticPaths({ locales }) {

  const missionSlugsWithCompany = (await getSlugsWithCompany()).map(params => params.slugWithCompany);

  let pathsAndLocale = [];
  locales.forEach(locale => {
    missionSlugsWithCompany.forEach(slug => {
      if (slug) {
        pathsAndLocale.push({
          params: {
            missionSlugWithCompany: slug
          },
          locale
        });
      }
    });
  });

  return {
    paths: pathsAndLocale,
    fallback: false
  };
}

export async function getStaticProps({ locale, params }) {
  const i18nConfig = await hackyServerSideTranslations(locale, [
    'betaBanner',
    'common',
    'footer',
    'home',
    'legal',
    'mission',
    'sectors',
    'metaData',
    'verifyAccount',
    'discord',
    'settings'
  ]);

  try {
    return {
      props: {
        ...i18nConfig,
        mission: await getMissionBySlugWithCompany(params.missionSlugWithCompany)
      }
    };
  } catch (e) {
    return { props: { ...i18nConfig }, notFound: true };
  }
}

export default MissionPage;
